import {
  Alert, Box, Button, Grid, IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import { Trash01, Plus } from '../../../assets';
import { useContext } from 'react';
import { StockCountCreateContext, StockCountCreateValues } from '../contexts/StockCountCreateContext';


const StockCountCreateCountZoneTypes = () => {
  const { t,
    isCountZoneConfigEnabled,
    countZoneTypesData,
    deleteCountZoneTypeRow,
    deleteCountZoneType,
    handleAddCountZoneTypesClick  } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const sortedCountZoneTypes = [...countZoneTypesData].sort((a, b) => 
    (a.name || '').localeCompare(b.name || ''),
  );
  const hasCountZoneTypes = sortedCountZoneTypes.length > 0;

  if (!isCountZoneConfigEnabled) {
    return <></>;
  }

  return (
    <Box sx={{ border: '1px solid' }}>
      <Grid container
        sx={{ pt: '12px', pb: '6px', px: '8px' }}>
        <Grid item
          xs={3}>
          <Typography variant="textMD"
            sx={{ fontWeight: 'bold' }}>{t('countZoneTypes.title')}</Typography>
        </Grid>
        <Grid item
          xs={9}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          {hasCountZoneTypes && (
            <Button
              size='lg'
              sx={{ mr: 4 }}
              variant='bad'
              onClick={() => deleteCountZoneType()}>
              <Trash01 />{t('deleteAll')}
            </Button>
          )}
          <Button
            size='lg'
            variant='primary'
            onClick={handleAddCountZoneTypesClick}><Plus />{t('add')}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ pt: '10px' }}>
        {hasCountZoneTypes ? (
          <TableContainer sx={{ overflowy: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('countZoneTypes.subtitle')}
                  </TableCell>
                  <TableCell
                    style={{ display: 'flex', justifyContent: 'flex-end' }} >{t('remove')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedCountZoneTypes?.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <Typography variant='textXS'
                        fontWeight={600}>
                        {row.name}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ display: 'flex', justifyContent: 'flex-end' }} >
                      <IconButton
                        onClick={() => { deleteCountZoneTypeRow(row.id ?? 0); }}>
                        <Trash01 style={{ color: 'red' }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert severity='info'
            variant='outlined'
            sx={{ mb: '12px', mx: '8px' }}>
            {t('countZoneTypes.noTypes')}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default StockCountCreateCountZoneTypes;
